import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=0a1607d4&scoped=true"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=0a1607d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1607d4",
  null
  
)

export default component.exports